import * as APIBase from './APIBase';

export default class NotificationsAPI {
  static get() {
    //return APIBase.getNotificationData();
    return APIBase.getAPI('/');
  }

  static delete() {
    return APIBase.deleteAPI('/', {});
  }
}
